import { useMemo } from "react"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import ExamResult from "@/exam/pages/ExamResult"
import { ExamProvider } from "@/exam/context"
import { createLearnerProvider } from "@/exam/provider"

export default function LearnerExamResult() {
  const { runId } = useParams()
  const [sp] = useSearchParams()
  const score = sp.get("score") || "0"
  const full = sp.get("full") || "0"
  const spend = sp.get("spend") || "0"
  const provider = useMemo(() => createLearnerProvider({ orgId: undefined, runId }), [runId])
  const nav = useNavigate()
  return (
    <ExamProvider provider={provider}>
      <ExamResult
        scoreParam={score}
        fullParam={full}
        spendParam={spend}
        onRetry={() => nav(`/learn/exam/${runId}`)}
      />
    </ExamProvider>
  )
}
